import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditorModule } from './editor/editor.module';
import { EditorComponent } from './editor/editor.component';


export const routes: Routes = [
  {path: 'editor/rate-audit', component: EditorComponent },
  {path: 'editor/reverse-audit', component: EditorComponent },
  {path: 'editor/rate-availability', component: EditorComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes),
  EditorModule],
  exports: [RouterModule]
})
export class NotificationsRoutingModule { }

export const routableModules = [
  EditorModule
]

